import { Box } from "@mui/material";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";

/** true cuando la app se compiló con REACT_APP_AMBIENTE=pruebas. */
export const esAmbientePruebas = process.env.REACT_APP_AMBIENTE === "pruebas";

/**
 * Etiqueta fija en la esquina inferior que recuerda que es el ambiente de
 * pruebas y que solo deben usarse datos ficticios (Ley 1581 de 2012).
 * No se muestra en local ni en producción.
 */
export const AvisoAmbiente = () => {
  if (!esAmbientePruebas) return null;
  return (
    <Box
      role="status"
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        borderRadius: 999,
        bgcolor: "#B45309",
        color: "#fff",
        fontSize: "0.8rem",
        fontWeight: 700,
        boxShadow: 6,
        pointerEvents: "none",
        maxWidth: "calc(100vw - 32px)",
      }}
    >
      <ScienceOutlinedIcon sx={{ fontSize: 18 }} />
      Ambiente de pruebas · usa solo datos ficticios
    </Box>
  );
};
